(() => {
  'use strict';

  const VERSION = '2026-09-10-v6-popup-media-lower';
  if (window.__SQ_SEARCH_POPUP_BAG_MEDIA_OWNER__ === VERSION) return;
  window.__SQ_SEARCH_POPUP_BAG_MEDIA_OWNER__ = VERSION;

  const ROOT = '#search-modal';
  const BAG = [
    '.sq-universal-bag',
    '[data-sq-universal-bag]',
    '[data-sq-universal-expanded-open]',
    '[data-sq-card-bag]',
    '[data-sq-bag-trigger]'
  ].join(',');
  const CARD = [
    '.sq-search-trending-card',
    '.sq-search-recent-card',
    '.sq-predictive-trending__card',
    '.sq-search-card',
    '.predictive-search__product-card',
    '.predictive-search-results__card--product',
    'product-card',
    '[data-sqyml2-card]'
  ].join(',');
  const MEDIA = [
    '.sq-search-trending-card__media',
    '.sq-search-recent-card__media',
    '.sq-predictive-trending__media',
    '.sq-predictive-card-cohesive__media',
    '.resource-card__media',
    '.sq-search-card__media',
    '.predictive-search__product-card-media',
    '.product-card__media',
    '.card-gallery',
    '.card__media',
    '.product-card__gallery',
    '.product-card__image-wrapper',
    '.product-card__media-wrapper',
    '.product-media-container'
  ].join(',');
  const IMAGE = 'img:not(.product-card-variant-belt__image):not(.pick-quick-option__swatch img)';

  let frame = 0;
  let observer = null;

  function host() {
    return document.querySelector(ROOT);
  }

  function isProductCard(card) {
    if (!(card instanceof HTMLElement)) return false;
    if (!card.closest(ROOT)) return false;
    return Boolean(
      card.matches('.sq-search-trending-card,.sq-search-recent-card,.sq-predictive-trending__card,product-card,[data-sqyml2-card]') ||
      card.querySelector('a[href*="/products/"]') ||
      card.hasAttribute('data-product-id') ||
      card.hasAttribute('data-product-handle')
    );
  }

  function mediaFor(card) {
    if (!(card instanceof HTMLElement)) return null;

    const image = card.querySelector(IMAGE);
    if (image instanceof HTMLImageElement) {
      const exact = image.closest(MEDIA);
      if (exact instanceof HTMLElement && card.contains(exact)) return exact;
    }

    const exact = card.querySelector(MEDIA);
    if (exact instanceof HTMLElement) return exact;

    const parent = image?.parentElement;
    return parent instanceof HTMLElement && parent !== card ? parent : null;
  }

  function write(style, property, value) {
    if (style.getPropertyValue(property) === value && style.getPropertyPriority(property) === 'important') return;
    style.setProperty(property, value, 'important');
  }

  function pinCard(card) {
    if (!isProductCard(card)) return;

    const bag = card.querySelector(BAG);
    if (!(bag instanceof HTMLElement)) return;

    const media = mediaFor(card);
    if (!(media instanceof HTMLElement)) return;

    /* The visible bag belongs to the image, not the title/price panel. */
    if (bag.parentElement !== media) {
      media.appendChild(bag);
    }

    write(media.style, 'position', 'relative');
    write(bag.style, 'position', 'absolute');
    write(bag.style, 'top', 'auto');
    write(bag.style, 'right', '10px');
    write(bag.style, 'bottom', '10px');
    write(bag.style, 'left', 'auto');
    write(bag.style, 'margin', '0px');
    write(bag.style, 'z-index', '96');
    write(bag.style, 'transform', 'none');

    bag.setAttribute('data-sq-search-popup-image-bag', 'true');
  }

  function scan(scope) {
    frame = 0;
    const root = host();
    if (!(root instanceof HTMLElement)) return;

    const cards = new Set();
    if (scope instanceof Element) {
      const own = scope.closest?.(CARD);
      if (own && root.contains(own)) cards.add(own);
      if (scope.matches?.(CARD) && root.contains(scope)) cards.add(scope);
      scope.querySelectorAll?.(CARD).forEach((card) => {
        if (root.contains(card)) cards.add(card);
      });
    } else {
      root.querySelectorAll(CARD).forEach((card) => cards.add(card));
    }

    cards.forEach(pinCard);
  }

  function schedule(scope) {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      scan(scope instanceof Element ? scope : null);
      requestAnimationFrame(() => scan());
    });
  }

  function installStyle() {
    let style = document.getElementById('sq-search-popup-bag-media-owner-v5');
    if (!style) {
      style = document.createElement('style');
      style.id = 'sq-search-popup-bag-media-owner-v5';
      document.head.appendChild(style);
    }

    style.textContent = `
      #search-modal :is(
        .sq-search-trending-card__media,
        .sq-search-recent-card__media,
        .sq-predictive-trending__media,
        .sq-predictive-card-cohesive__media,
        .resource-card__media,
        .sq-search-card__media,
        .predictive-search__product-card-media,
        .product-card__media,
        .card-gallery,
        .card__media,
        .product-card__gallery
      ) > :is(
        .sq-universal-bag,
        [data-sq-universal-bag],
        [data-sq-universal-expanded-open],
        [data-sq-card-bag],
        [data-sq-bag-trigger]
      ) {
        position: absolute !important;
        top: auto !important;
        right: 10px !important;
        bottom: 10px !important;
        left: auto !important;
        margin: 0 !important;
        z-index: 96 !important;
        transform: none !important;
      }
    `;
  }

  function boot() {
    installStyle();

    const root = host();
    if (!(root instanceof HTMLElement)) {
      window.setTimeout(boot, 60);
      return;
    }

    schedule(root);

    observer?.disconnect();
    observer = new MutationObserver((records) => {
      let relevant = false;
      for (const record of records) {
        if (record.type === 'childList' && (record.addedNodes.length || record.removedNodes.length)) {
          relevant = true;
          break;
        }
        if (record.type === 'attributes') {
          const target = record.target;
          if (
            target instanceof Element &&
            (target.matches(BAG) || target.closest(CARD))
          ) {
            relevant = true;
            break;
          }
        }
      }
      if (relevant) schedule(root);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    root.addEventListener('pointerover', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const card = target?.closest(CARD);
      if (card) schedule(card);
    }, { passive: true });

    root.addEventListener('focusin', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const card = target?.closest(CARD);
      if (card) schedule(card);
    });

    [
      'predictive-search:updated',
      'sq:universal-bag-ready',
      'sq:search-intent-refined',
      'sq:search-recently-viewed-rendered',
      'dialog:after-show',
      'shopify:section:load'
    ].forEach((name) => document.addEventListener(name, (event) => schedule(event.target)));

    window.addEventListener('resize', () => schedule(root), { passive: true });
    window.addEventListener('orientationchange', () => schedule(root), { passive: true });
    window.addEventListener('pageshow', () => schedule(root), { passive: true });

    [0, 40, 120, 260, 520, 900, 1500].forEach((delay) => {
      window.setTimeout(() => schedule(root), delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
